(function() {
  'use strict';

  // ── ToC Sidebar Clone ──────────────────────────────────────────
  function initToC() {
    var inlineNav = document.querySelector('#table-of-contents');
    var tocSlot = document.querySelector('.pl-article-body__toc-slot');
    var tocToggle = document.querySelector('.pl-article-body__toc-toggle');

    if (!inlineNav || !tocSlot) {
      // No ToC in article — hide the toggle container
      if (tocToggle) tocToggle.style.display = 'none';
      return;
    }

    // Clone into the sidebar slot, then REMOVE the inline nav from the DOM.
    // (Using `display: none` would keep it in the DOM and trigger Impact's
    // `.prose > * + *` adjacent-sibling margin rule on the first heading,
    // leaving a phantom gap above the first visible element.)
    var cloned = inlineNav.cloneNode(true);
    cloned.removeAttribute('id');
    cloned.style.display = '';
    tocSlot.appendChild(cloned);
    inlineNav.remove();

    // Mobile: remove 'open' so toggle starts collapsed
    if (tocToggle && window.matchMedia('(max-width: 699px)').matches) {
      tocToggle.removeAttribute('open');
    }

    initToCHighlight(cloned);
  }

  // ── Active Section Highlight ───────────────────────────────────
  function initToCHighlight(tocNav) {
    var tocLinks = Array.from(tocNav.querySelectorAll('a[href^="#"]'));
    if (!tocLinks.length) return;

    var headingIds = tocLinks.map(function(a) {
      return a.getAttribute('href').slice(1);
    });

    var headings = headingIds.map(function(id) {
      return document.getElementById(id);
    }).filter(Boolean);

    if (!headings.length) return;

    var activeLink = null;
    var clickLocked = false; // prevents observer from overriding click navigation
    var visibleSet = new Set(); // tracks which headings are currently in the viewport

    function activate(link) {
      if (link === activeLink) return;
      if (activeLink) activeLink.classList.remove('toc-active');
      if (link) {
        link.classList.add('toc-active');
        // Scroll the ToC nav so the active link stays visible
        if (tocNav.scrollHeight > tocNav.clientHeight) {
          var li = link.closest('li') || link;
          var top = li.offsetTop;
          var center = top - tocNav.clientHeight / 2 + li.offsetHeight / 2;
          tocNav.scrollTo({ top: Math.max(0, center), behavior: 'smooth' });
        }
      }
      activeLink = link;
    }

    // On ToC click: immediately activate the target, lock observer briefly
    tocLinks.forEach(function(link) {
      link.addEventListener('click', function() {
        link.blur();
        clickLocked = true;
        activate(link);
        setTimeout(function() { clickLocked = false; }, 150);

        // Compensate for layout shift caused by lazy-loaded images without
        // reserved space (i.e. converter-output before the width/height fix).
        // Future articles emit pixel-dim attrs → no shift → this is a no-op.
        var targetId = link.getAttribute('href').slice(1);
        var target = document.getElementById(targetId);
        if (target) setTimeout(function() { compensateClsToTarget(target); }, 0);
      });
    });

    var observer = new IntersectionObserver(function(entries) {
      // Update visibility state for each reported heading
      entries.forEach(function(entry) {
        var id = entry.target.getAttribute('id');
        if (entry.isIntersecting) {
          visibleSet.add(id);
        } else {
          visibleSet.delete(id);
        }
      });

      // Don't override during click navigation
      if (clickLocked) return;

      // Find the topmost visible heading (in DOM order)
      var topmost = null;
      for (var i = 0; i < headings.length; i++) {
        if (visibleSet.has(headings[i].getAttribute('id'))) {
          topmost = headings[i];
          break;
        }
      }

      if (topmost) {
        var link = tocNav.querySelector('a[href="#' + topmost.getAttribute('id') + '"]');
        activate(link);
      }
    }, {
      rootMargin: '0px 0px -40% 0px',
      threshold: 0
    });

    headings.forEach(function(h) { observer.observe(h); });
  }

  // ── ToC-click CLS compensation ─────────────────────────────────
  // After the browser's anchor scroll, watch images above the target.
  // As each lazy image loads it pushes content down — re-scroll to keep
  // the target heading aligned with the page's anchor-scroll offset.
  // The offset comes from `scroll-padding-block-start` set on <html>
  // (= sticky-area-height + 20px in theme.css), with any per-target
  // `scroll-margin-top` added on top. Reading these matches what the
  // browser itself uses for hash navigation, so the re-scroll lands
  // headings at the same position as the initial click.
  // User-initiated scroll cancels compensation so we never fight the user.
  // Safety timeout cleans up listeners after 5s.
  function compensateClsToTarget(target) {
    var allImgs = Array.from(document.querySelectorAll('img'));
    var targetTop = target.getBoundingClientRect().top + window.scrollY;

    var pendingImgs = allImgs.filter(function(img) {
      if (img.complete) return false;
      var imgTop = img.getBoundingClientRect().top + window.scrollY;
      return imgTop < targetTop;
    });

    if (!pendingImgs.length) return;

    var cancelled = false;
    var pendingCount = pendingImgs.length;

    function cleanup() {
      window.removeEventListener('wheel', onUserScroll);
      window.removeEventListener('touchstart', onUserScroll);
      window.removeEventListener('keydown', onUserScroll);
    }
    function onUserScroll() { cancelled = true; cleanup(); }

    // Defer one frame so the browser's anchor scroll lands first; only then
    // start treating new scroll events as "user wants to cancel".
    requestAnimationFrame(function() {
      window.addEventListener('wheel', onUserScroll, { passive: true, once: true });
      window.addEventListener('touchstart', onUserScroll, { passive: true, once: true });
      window.addEventListener('keydown', onUserScroll, { passive: true, once: true });
    });

    function getDesiredTop() {
      var rootStyles = getComputedStyle(document.documentElement);
      var pad = parseFloat(rootStyles.scrollPaddingTop) || 0;
      var mar = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
      return pad + mar;
    }

    function recheck() {
      if (cancelled) return;
      var rect = target.getBoundingClientRect();
      var drift = rect.top - getDesiredTop();
      if (Math.abs(drift) > 2) {
        window.scrollBy({ top: drift, behavior: 'instant' });
      }
    }

    var safetyTimer = setTimeout(function() { cancelled = true; cleanup(); }, 5000);

    pendingImgs.forEach(function(img) {
      function onSettled() {
        img.removeEventListener('load', onSettled);
        img.removeEventListener('error', onSettled);
        pendingCount--;
        recheck();
        if (pendingCount === 0) {
          clearTimeout(safetyTimer);
          cleanup();
        }
      }
      img.addEventListener('load', onSettled);
      img.addEventListener('error', onSettled);
    });
  }

  // Expose so pl-share-quote.js can reuse this for hash-share landings.
  window.plCompensateClsToTarget = compensateClsToTarget;

  // ── Init ───────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initToC);
  } else {
    initToC();
  }
})();
